import React from 'react';

import {SCOPE_KEY} from 'src/modules/profile/user/tabs/content/workspace/util';
import {WorkspaceRequestSortBy} from 'src/openapi/admin/models/WorkspaceRequest';

import {SortHeaderWithDataTable} from '@pb/kit-component-sort-header';
import {Cell} from '@pb/kit-component-table';

import {uiToApiSort} from '../../utils/util';
import {useWorkspaceCriteria} from '../hooks/useWorkspaceCriteria';

export const WorkspaceHeader = () => {
    const {criteria, setSort} = useWorkspaceCriteria(SCOPE_KEY);

    return (
        <Cell width={370} className="nowrap">
            <SortHeaderWithDataTable
                caption="Workspace Name"
                defaultDirection="ASC"
                direction={criteria?.sortBy === WorkspaceRequestSortBy.NAME
                    ? criteria.sortDirection
                    : undefined}
                onSort={dir => setSort(WorkspaceRequestSortBy.NAME, uiToApiSort(dir))}
            />
        </Cell>
    );
};
